import { createFileRoute } from '@tanstack/react-router';
import { requireBoardFeature } from '@/features/board/guard';
import { BoardView } from '@/features/board/board-view';
import { parseBoardSearch, withBoardTask } from '@/features/board/board-search';
import { useProject } from '@/features/projects/use-project';
import { TaskPanel } from '@/features/tasks/task-panel';

/** KAN-01: board of a project; filters and swimlanes in the URL, `?task=KEY-1` opens the panel. */
export const Route = createFileRoute('/_app/p/$projectKey/board')({
  validateSearch: (raw: Record<string, unknown>) => parseBoardSearch(raw),
  beforeLoad: ({ context }) => requireBoardFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const project = useProject(projectKey);
  const linkTo = (key: string) => ({
    to: '/p/$projectKey/board' as const,
    params: { projectKey: project.key },
    search: withBoardTask(search, key),
  });
  return (
    <>
      <BoardView
        project={project}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
        linkTo={linkTo}
      />
      <TaskPanel
        projectKey={project.key}
        taskKey={search.task}
        linkTo={linkTo}
        onTaskChange={(key, options) => {
          void navigate({ search: withBoardTask(search, key), replace: options?.replace === true });
        }}
      />
    </>
  );
}
